<div class="attachment-menu-container">
  <div class="attachment-list">
    @for (attachment of attachmentsList(); track attachment) {
      <div class="attachment">
        <img class="attachment__icon" src="{{attachment.iconUrl}}" alt=""/>
        <span class="attachment__name">{{attachment.filename}}</span>
        <button class="attachment__remove" (click)="removeClicked(attachment, $event)">
          <img src="assets/icons/common/remove.svg" alt="Remove attachment {{attachment.filename}}">
        </button>
      </div>
    }
  </div>
  <button class="add-file" (click)="triggerFileInput()">
    <img class="add-file__icon" src="assets/icons/common/add.svg" alt="">
    <input id="attachments"
      #attachmentFile
      type="file"
      accept="{{fileTypeWhiteList}}"
      style="display:none;"
      name="attachments"
      multiple
      (change)="filesChanged($event)">
      <span class="add-file__text">Add File</span>
    </button>
  </div>
